import React, { memo, useMemo } from "react";
import MessageStatusMC from "./MessageStatusMC";
import GroupSenderMC from "./GroupSenderMC";

const PostMessageMC = memo(({ message, conversation }) => {
  const messageContent = useMemo(
    () => <div dangerouslySetInnerHTML={{ __html: message.messageText }} />,
    [message.messageText]
  );

  return (
    <div className="tw-wrapper tw-whitespace-pre-line tw-text-sm">
      <GroupSenderMC message={message} />
      <a href={message.postUrl} target="_blank" rel="noreferrer" className="tw-text-blue-500 tw-underline hover:tw-text-blue-600 tw-break-all">
        {message.postUrl}
      </a>
      {messageContent}
      <MessageStatusMC message={message} platform={conversation.platform} />
    </div>
  );
});

PostMessageMC.displayName = 'PostMessageMC';

export default PostMessageMC;
